import React from 'react';
import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { VersionHistoryList, DASHBOARD } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES, PAGE_NAMES, DASHBOARD_RESOURCES } from 'constant';

const getId = (): string => {
	const location = useLocation();
	return _get(location, ['state', 'rowData', '_id']);
};

const VersionHistory: React.FC<{}> = () => {
	const id = getId();

	return (
		<VersionHistoryList
			entity={LIST_ENTITY_NAMES.BANNERS}
			dashboard={DASHBOARD.MARKETING}
			id={id}
			pageName={PAGE_NAMES.dashboard}
			entityName={DASHBOARD_RESOURCES.banner}
			usePageActions={useDashboardActions}
		/>
	);
};

export default VersionHistory;
